import { fetchRefreshToken } from './fetchRefreshToken'
import { removeCodeFromLocation } from './removeCodeFromLocation'
import { removeStateFromStorage } from './removeStateFromStorage'
import { AES, enc } from 'crypto-js';
import { store } from '../../redux/_helpers/store';
// import { connect } from 'react-redux';
import { fetchTokenPath, redirectURIPath } from '../../Services/config/apiGateway';
import { success } from '../../redux/_actions/login.actions';
import Cookies from 'cookies-js';

export const fetchToken = ({ clientId, scopes, clientSecret, code, state, tokenEndpoint, fetch = window.fetch, storage = sessionStorage, }) => {
  const payload = {
    client_id: '1ad286a0-ab7d-4952-bfe4-5f47eafaac7f',
    code,
    grant_type: 'authorization_code',
    code_verifier: state.encodedVerifier,
    redirect_uri: state.redirect_uri,
    scope: "8c19ff6c-0af1-48e9-b5ef-005a9a59e409 offline_access"
  };
  const codeVerifier = storage.getItem('_Verenc')//'ThisIsntRandomButItNeedsToBe43CharactersLong'//storage.getItem('_Verenc')
  console.log("CODE+==>  ", code)
  // if (clientSecret) {
  //   payload.client_secret = clientSecret
  // }
  //https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/tokenprofiledetails?grant_type=authorization_code&client_id=f1d4d39a-5888-481c-a562-a49d7748f054&scope=f1d4d39a-5888-481c-a562-a49d7748f054%20offline_access&code=${code}&redirect_uri=http://localhost:3000&code_verifier={state.encodedVerifier}
  //Working one>> https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/tokenbackendaggregation?grant_type=authorization_code&client_id=f1d4d39a-5888-481c-a562-a49d7748f054&scope=f1d4d39a-5888-481c-a562-a49d7748f054 offline_access&code=${code}&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}`
  //https://tptcargodevsa.z1.web.core.windows.net


  return fetch(`${fetchTokenPath}tokenprofiledetails?code=${code}&redirect_uri=${redirectURIPath}&code_verifier=${codeVerifier}`, {
    // return fetch(`https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/tokenprofiledetails?code=${code}&redirect_uri=https://www.dev-cargoconnectadmin.transnetportterminals.net&code_verifier=${codeVerifier}`, {
    // return fetch(`https://tpt-apim-cargo-test.azure-api.net/ccLoginAdmin/v1/tokenprofiledetails?code=${code}&redirect_uri=https://www.test-cargoconnectadmin.transnetportterminals.net&code_verifier=${codeVerifier}`, {


    //   return fetch(`https://tpt-apim-cargo-dev.azure-api.net/ccLoginAdmin/v1/tokenprofiledetails?code=${code}&redirect_uri=http://localhost:3000&code_verifier=${codeVerifier}`, {
    //return fetch(`https://tpt-apim-cargo-dev.azure-api.net/ccLogin/v1/tokenbackendaggregation?grant_type=authorization_code&code=${code}&redirect_uri=http://localhost:3000&code_verifier=${state.encodedVerifier}`, {
    // headers: {
    //   'x-cc-trace-id' :"xyz"
    //   // 'Access-Control-Allow-Origin': '*'
    // },
    method: 'GET',
    //body: new window.URLSearchParams(payload)
  })
    .then(r => {
      if (!r.ok) {
        throw new Error(`Token response not ok, status is ${r.status}`);
      }
      //console.log(r.toS())
      console.log(r, "===>>>>>API Response")
      return r.json();
      //return r
    })
    .then(token => {
      //cookies.set('msAL_admin_dev', token.tokenResponse, { path: '/' });
      // Cookies.set('msAL_admin_dev', token.tokenResponse.access_token, { path: '/' });

      // const tokenencripted = AES.encrypt(JSON.stringify("abc"),'itsEncrypted').toString();
      // Cookies.set('msAL_admin_dev',tokenencripted,  { expires: token.tokenResponse.expires_in, path:'/' });

      // console.log(Cookies.get('msAL_admin_dev'))

      const tokenencripted = AES.encrypt(JSON.stringify(token.tokenResponse.access_token), 'itsEncrypted1').toString();
      Cookies.set('msAL_admin_dev', tokenencripted, { expires: token.tokenResponse.expires_in, path: '/' });
      // Cookies.set('msAL_admin_dev',token.tokenResponse.access_token,  { expires: token.tokenResponse.expires_in, path:'/' });
      Cookies.set('msAL_adminRef_dev', token.tokenResponse.refresh_token, { expires: token.tokenResponse.expires_in, path: '/' });
      console.log(token.tokenResponse); // Pacman
      const envryptedToken = AES.encrypt(JSON.stringify(token), 'itsEncrypted').toString();
      sessionStorage.setItem("isAuthenticated", envryptedToken);

      const refreshToken = sessionStorage.getItem("isAuthenticated");
      const decrypted = AES.decrypt(refreshToken, 'itsEncrypted');
      const decryptedObject = decrypted.toString(enc.Utf8);
      const getRefreshToken = JSON.parse(decryptedObject);
      sessionStorage.setItem("Decrypted Token", JSON.stringify(getRefreshToken))
      Cookies.set('msAL_t0k3N_dev', token, { path: '/' });


      //console.log(token.backendResponse,"RESPONSE++++++++")
      console.log(token,token.backendResponse)
      const loginDataStore = {
        ...token.backendResponse,
        personFirstNameR: token.backendResponse.userDetails.userdetails.user.firstName,
        personLastNameR: token.backendResponse.userDetails.userdetails.user.lastName,
      }
      const encryptedToken = AES.encrypt(JSON.stringify(loginDataStore), 'TPT_CARGO_CONNECT').toString();
      // store.dispatch(success(encryptedToken));
      // if(token.backendResponse.userDetails.isSuperAdmin || token.backendResponse.userType != ("Preview" || "Premium")) {
      // use  for private routing
      token.loginSuccess = "YES"

      // localStorage.setItem("loginSuccess","YES"); 

      // localStorage.setItem('firstName',data.userDetails.userdetails.user.firstName);
      // localStorage.setItem('lastName',data.userDetails.userdetails.user.lastName);
      // localStorage.setItem('role',data.userDetails.roles.length)

      // if(data.userDetails.roles.length>0){
      //     localStorage.setItem("permission", JSON.stringify(data.userDetails.roles[0].permissions))
      // } 
      console.log(token)
      if (loginDataStore) {
        const encryptedTokenn = AES.encrypt(JSON.stringify(token.backendResponse), 'TPT_CARGO_CONNECT').toString();
        // Cookies.set('TPT_CARGO_CONNECT1_dev',(encryptedTokenn),  { expires: token.tokenResponse.expires_in, path:'/' });
        store.dispatch(success(encryptedTokenn));
        console.log(encryptedTokenn, store.dispatch(success(encryptedTokenn)))
      }
      // store.dispatch(success(token.backendResponse));
      // window.location.replace("/Dashboard");

      // }
      const { expires_in } = token;
      if (expires_in && Number.isFinite(expires_in)) {
        const slackSeconds = 10;
        // add 'expires_at', with the given slack
        token.expires_at = new Date(new Date().getTime() + expires_in * 1000 - (slackSeconds * 1000));
        console.log(token, "==>>>>> myToken")
        //Refresh Token
        //setCookie('msAL_admin_dev', token.tokenResponse, { path: '/', expires:token.expires_at, maxAge:1000 });


        setInterval(() => {
          fetchRefreshToken({
            clientId, clientSecret, tokenEndpoint, code, state, fetch
          })
            .then()
            .then(() => {
              removeCodeFromLocation()
              removeStateFromStorage({ clientId, storage })
            })
            .catch(e => {
              console.error(e)
              console.log(`Error fetching auth token from REFRESH Token API: ${e.message}`)
            })

        }, 3580 * 60);
      }
      return token;
    })
    .catch(err => {
      console.error('ERR (fetch)', err);
      throw err;
    });
}
